import { InjectionToken } from "@angular/core";
import { ReconciliationDashboardPort } from "./reconciliation-dashboard.port";

export const RECONCILIATION_DASHBOARD_PORT =
  new InjectionToken<ReconciliationDashboardPort>("RECONCILIATION_DASHBOARD_PORT");
